var createNewLookupObject = {};

export { createNewLookupObject as __exports };
//# sourceMappingURL=create-new-lookup-object.js.map
